import React, { useEffect, useState } from "react";
import "./tasksdetails.scss";
import "../Similartaskdetail/similartaskdetail.scss";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-bootstrap/Pagination";
import Navbar from "../landing/header/Navbar";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../utils/ApiUrl";
import moment from "moment";
import { slice } from "lodash";
import TaskTimer from "./TaskTimer";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import RefundTask from "../../hooks/write/refundTask";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../../hooks/useWeb3";
import useSignature from "../../hooks/userSign1";
import Loader from "../../hooks/loader";
import RedeemTask1 from "../../hooks/write/redeemTask1";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { updateTaskStatus } from "../../services/statusCompleted";
import { tokenImages } from "../../constants/tokenImages";
import TaskCard from "../Similartaskdetail/TaskCard";
import useFetchTaskData from "../../hooks/similarTaskDetail/useFetchTaskData";
import useParticipate from "../../hooks/similarTaskDetail/useParticipate";
import useCreateDispute from "../../hooks/similarTaskDetail/useCreateDispute";
import CustomToast from '../../components/CustomToast';



const Tasksdetails = () => {
  const { redeemTask1 } = RedeemTask1();
  const { account } = useWeb3React();
  const { userSign } = useSignature();
  const { refundTask } = RefundTask();
  const web3 = useWeb3();
  const [proveOfWorkUser, setProveOfWorkUser] = useState(null);
  const [loader, setLoader] = useState(false);
  const [createrState, setCreater] = useState(false)
  const [taskData, setTaskData] = useState(null); // State for storing fetched task data
  const [taskData1, setTaskData1] = useState(null); // State for storing fetched task data
  const { id } = useParams(); // Get the task ID from the URL
  const [timeshow, setTimeshow] = useState(false);
  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);

  // console.log(taskData, "taskDatataskDatataskDatataskDatataskDatas");


  const [pages, setPages] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [arry, setArry] = useState([]);
  // console.log(arry, 'arryarry');

  const [TimerCheck, setTimerCheck] = useState({});
  const [contractId, setContractId] = useState(null);
  const [creater, setCreat] = useState(null);
  const [currentTime, setCurrentTime] = useState('');
  const [newEndTime, setNewEndTime] = useState('');
  const [extended, setExtended] = useState(false)
  // Function to update current time dynamically


  const [taskIds, setTaskIds] = useState();

  const errorMsg = () => {
    // toast.error("Connect Wallet!");
    CustomToast.show('error', 'Error!', 'Connect Wallet!')

  };

  const navigate = useNavigate();
  useEffect(() => {
    const updateCurrentTime = () => {
      const now = new Date();
      const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true, // 12-hour format with AM/PM
      };
      setCurrentTime(now.toLocaleString('en-US', options));
    };

    updateCurrentTime();
    const interval = setInterval(updateCurrentTime, 60000); // Update every minute
    return () => clearInterval(interval);
  }, []);



  const handleConfirm = async () => {
    setLoader(true)
    try {
      const now = new Date();
      const maxEndDate = new Date();
      maxEndDate.setDate(now.getDate() + 30);

      const selectedEndDate = new Date(newEndTime);

      if (selectedEndDate > maxEndDate) {
        // toast.info(`Task duration cannot exceed 30 days from now. The maximum allowed date and time is: ${maxEndDate.toISOString().replace('T', ' ').split('.')[0]} UTC`);
        CustomToast.show('warning', 'Warning!', `Task duration cannot exceed 30 days from now. The maximum allowed date and time is: ${maxEndDate.toISOString().replace('T', ' ').split('.')[0]} UTC`)





        setLoader(false)
        return;
      }

      const accessToken = localStorage.getItem('accessToken');
      const payload = {
        endTime: selectedEndDate.toISOString(),
      };

      const response = await axios.patch(`${API_URL}tasks/${id}/extend-endtime`, payload, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.status === 200) {
        fetchTaskData()
        handleShow5();
        handleClose3();
        setLoader(false)
      }
    } catch (error) {
      setLoader(false)
      console.error('Error extending task duration:', error);
      // toast.error('Failed to extend task duration. Please try again.');
      CustomToast.show('error', 'Error!', 'Failed to extend task duration. Please try again.')
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const time = new Date("Dec 20, 2024 08:00:00");
      const diff = time.getTime() - now.getTime();
      if (diff <= 0) {
        clearInterval(interval);
        setTimeshow(true);
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);

      // Calculate the total seconds for the initial time
      const initialTotalSecs = 97 * 3600 + 97 * 60 + 97;
      const totalSecs =
        days * 24 * 3600 + hours * 3600 + mins * 60 + secs + initialTotalSecs;

      // Convert total seconds back to days, hours, minutes, and seconds
      const updatedDays = Math.floor(totalSecs / (24 * 3600));
      const updatedHours = Math.floor((totalSecs % (24 * 3600)) / 3600);
      const updatedMins = Math.floor((totalSecs % 3600) / 60);
      const updatedSecs = Math.floor(totalSecs % 60);

      setDay(updatedDays);
      setHour(updatedHours);
      setMin(updatedMins);
      setSec(updatedSecs);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [show4, setShow4] = useState(false);
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);


  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show5, setShow5] = useState(false);
  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);


  const fetchTaskData = async () => {
    setLoader(true);
    // console.log("Fetched Task data function calleddddddddddd");
    try {
      // Get the accessToken from localStorage
      const accessToken = localStorage.getItem("accessToken");

      // Set up the config with headers
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Add the token to the Authorization header
        },
      };

      // Make the API request with the Authorization header
      const response = await axios.get(`${API_URL}tasks/${id}`, config);
      // Store the fetched data in the state
      // console.log(response?.data?.data, 'response?.data?.data');
      setTaskData(response?.data?.data);
      // setArry(response?.data?.data?.participants);
      setTimerCheck(calculateTimeLeft(response?.data?.data));
      setLoader(false);
    } catch (error) {
      console.error("Error fetching task data:", error);
      navigate("/error404")
      setLoader(false);
    }
  };
  const fetchTaskData1 = async () => {
    let ids = parseInt(id);
    setLoader(true);
    try {
      // Get the accessToken from localStorage
      const accessToken = localStorage.getItem("accessToken");

      // Set up the config with headers
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Add the token to the Authorization header
        },
      };

      // Make the API request with the Authorization header
      const response = await axios.get(
        `${API_URL}participants/${ids}?limit=${5}&offset=${page + 1}`,
        config
      );
      // Store the fetched data in the state

      // setTaskData1(response?.data?.data);
      let value = response?.data?.data;
      // console.log(value, 'arryarry');

      setPageCount(value.count / 5);
      setPages(value.pages);
      setArry(value.participants);
      setContractId(value.contractTaskId);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching task data:", error);
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchTaskData();
    fetchTaskData1();
    window.scrollTo(0, 0);
  }, [id, page]);


  const { curruntStatus, isWinner } = useFetchTaskData(taskData, id, setTaskData, setLoader, account)
  const { uniqueCode, uniqueStatus, userId, participate, fetchPrticipateData } = useParticipate(fetchTaskData, handleClose, setLoader, taskIds, handleShow1, taskData, id);

  const { createDispute } = useCreateDispute(id, account, taskData, setLoader, fetchTaskData);

  const clickme = (ee) => {
    // console.log(ee, "es");
    handleShow();
    setProveOfWorkUser(ee);
  };

  const handlePageChange = (e) => {
    const selectedPage = e.selected;
    setPage(selectedPage);
  };
  const download = (e) => {
    const fileUrl = e; // Your file URL
    const fileName = "Task file"; // Desired file name
    window.open(fileUrl, "_blank");
    // Create an anchor element
    const link = document.createElement("a");
    // link.href = fileUrl;
    link.download = fileName;

    // Append the anchor to the document and trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the anchor from the DOM
    document.body.removeChild(link);
  };

  const winnerFinal = async () => {
    // // console.log(proveOfWorkUser?.user?.walletAddress, contractId, 'proveOfWorkUser');
    setCreater(false)
    let v = await userSign(proveOfWorkUser?.user?.walletAddress, contractId);
    if (v) {
      let sigg = localStorage.getItem("sign");
      let accessToken = localStorage.getItem("accessToken");
      setLoader(true);
      var config = {
        method: "patch",
        url: `${API_URL}participants/${proveOfWorkUser.id}/winner`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Include the access token here
        },
        data: {
          status: "winner",
          creatorSignature: v,
        },
      };
      try {
        let response = await axios(config);

        if (response) {
          handleClose1();
          fetchTaskData();
          setLoader(false);
          handleShow2();
        }
      } catch (error) {
        console.error("Error occurred while creating task:", error);
        setLoader(false);
        // toast.error(error.message);
        CustomToast.show('error', 'Error!', error.message)

      }
    }
  };

  function calculateTimeLeft(e) {
    const difference = new Date(e?.endTime) - new Date(); // Calculate time difference
    let timeRemaining = {};

    if (difference > 0) {
      timeRemaining = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeRemaining = false;
    }

    return timeRemaining;
  }
  // // console.log(TimerCheck, 'TimerCheck');

  const claimRefund = async () => {
    let signn = localStorage.getItem("sign");
    setLoader(true);
    console.log(creater?.signedKeyDetails.taskId, creater?.signedKeyDetails.signerSignature, 'creater?.signedKeyDetails.taskId,creater?.signedKeyDetails.signerSignature');
    try {
      let valeu = await refundTask(
        creater,
        creater?.signedKeyDetails.taskId,
        creater?.signedKeyDetails.signerSignature
      );
      if (valeu) {
        await updateTaskStatus(taskData?.id)
        handleClose4();
        handleShow2();
        fetchTaskData()
      }
      setLoader(false);
    } catch (err) {
      setLoader(false);
    }
  };


  const apiCallHandler = async (e) => {
    setCreater(true)
    let accessToken = localStorage.getItem("accessToken");
    let signg = localStorage.getItem("sign");
    setLoader(true);
    var config = {
      method: "get",
      url: `${API_URL}tasks/${taskData.id}/signature/refund`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Include the access token here
      },
    };
    try {
      let response = await axios(config);

      if (response) {
        // // console.log('Task created successfully:', response.data.data);
        handleShow4();
        setCreat(response.data.data);
        fetchTaskData()
        setLoader(false);
        //    setWinnerData(e)
      }
    } catch (error) {
      // toast.error(error.message);
      CustomToast.show('error', 'Error!', error.message)
      setLoader(false);
      console.error("Error occurred while creating task:", error);
      setLoader(false);
    }
  };

  const apiCallHandler1 = async (e) => {
    // setdatata(e)
    setCreater(true)
    setLoader(true);
    // setSelectedIs(e?.id)
    let accessToken = localStorage.getItem("accessToken");
    let signg = localStorage.getItem("sign");
    var config = {
      method: "get",
      url: `${API_URL}tasks/${taskData.id}/signature/dispute`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Include the access token here
      },
    };
    try {
      let response = await axios(config);

      if (response) {
        // console.log('Task created successfully:', response.data.data);
        // handleShow6()
        handleShow4();
        setCreat(response.data.data);
        fetchTaskData()
        setLoader(false);
        fetchTaskData()
        //    setWinnerData(e)
      }
    } catch (error) {
      console.error("Error occurred while creating task:", error);
      setLoader(false);
    }
  };
  // console.log(taskData, 'taskDatataskData');

  const claimToken1 = async () => {
    // console.log('dsadsdasdad');
    let sign = localStorage.getItem("sign");
    // // console.log(winnerData?.task, 'sddsadasasd');\
    // console.log(creater, sign, 'signsignsign');
    setLoader(true);
    try {
      let value = await redeemTask1(creater, sign);
      if (value) {
        await updateTaskStatus(taskData?.id)
        handleClose4();
        handleShow2();
        fetchTaskData()
      }
      setLoader(false);
    } catch (err) {
      // console.log(err, "contract erro");
      setLoader(false);
      // toast.error("Something went wrong!");
      CustomToast.show('error', 'Error!', 'Something went wrong!')
    }
  };
  // Utility function to make URLs clickable
  const makeUrlsClickable = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) =>
      urlRegex.test(part) ? (
        <a
          key={index}
          href={part}
          target="_blank"
          className="text-secondary text-decoration-underline"
          rel="noopener noreferrer"
        >
          {part}
        </a>
      ) : (
        part
      )
    );
  };
  const renderTooltipEdit = (props) => (
    <Tooltip id="button-tooltip " className="tolltipssss" {...props}>
      You can edit a task as long as no participants have joined. Once someone joins, editing will be locked to keep things fair and avoid changing the requirements. Please note that the Reward Amount, Currency, Task Title, and Task Description cannot be edited at any stage.
    </Tooltip>
  );
  function editTask() {
    navigate(`/createtask?edit=${id}`)
  }
  // const tokenImages = {
  //   ETH: "/assets/createtask/eth.svg",
  //   USDT: "/assets/createtask/usdtT.svg",
  //   USDC: "/assets/createtask/usdc.svg",
  //   LINK: "/assets/createtask/link.svg",
  //   PEPE: "/assets/createtask/pepe.svg",
  //   UNI: "/assets/createtask/uni.svg",
  //   DOP: "/assets/createtask/dop1.svg",
  //   WBTC: "/assets/createtask/wbtc.svg",
  //   Tomi: "/assets/createtask/tomi.svg",
  // };
  useEffect(() => {
    if (id && isNaN(id)) {
      navigate("/error404")
      //  <Navigate to= />;
    }
  }, [id])
  useEffect(() => {
    if (taskData?.submissionCount < 1 && !taskData?.isEndTimeExtended) {
      setExtended(true)
    }
  }, [taskData])

  //   console.log(proveOfWorkUser, "proveOfWorkUser");
  return (
    <>
      {loader && <Loader />}
      {/* <Navbar /> */}
      <section className="tasksdetails">
        <img
          src="/assets/importantassets/detailbackshade.png"
          alt="backshade"
          className="backshade"
        />
        <img
          src="/assets/importantassets/detailbackshadembl.png"
          alt="backshade"
          className="backshadembl d-none"
        />
        <div className="custom-container">
          <p className="toppara">
            <span className="light">Home </span>/{" "}
            {taskData?.tasksCategory?.categoryName}
          </p>
          <div className="detailmain">
            <div className="detailsleft">
              {/* <span className="statusmain">
                                <span className="statuscircle"></span>
                                <p className="statuspara">PARTICIPATED</p>
                            </span> */}
              <h4 className="detailhead">{taskData?.title}</h4>
              {/* {taskData?.deliveryFormat?.length > 0 && <div className='formate'>
                                <h3 className='formatehead '>Delivery Format</h3>
                                <div className='mainbuttons '>
                                    {taskData?.deliveryFormat?.map((item) => <button>{item}</button>)}
                                </div>
                            </div>} */}
              <div className="parentsdiv">
                {taskData?.serviceType === "digital" || (
                  <div className="left">
                    <p className="locationparaaaaaaa">Location</p>
                    <div className="boxxxxxx">
                      {taskData?.locations &&
                        Object.entries(taskData.locations).map(
                          ([country, cities]) => (
                            <p key={country}>
                              {country}, {cities.join(", ")}
                            </p>
                          )
                        )}
                    </div>
                  </div>
                )}
                {taskData?.deliveryFormat?.length > 0 && (
                  <div className="formate">
                    <h3 className="formatehead ">Delivery Format</h3>
                    <div className="mainbuttons ">
                      {taskData?.deliveryFormat?.map((item) => (
                        <button>{item}</button>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="mainheadingggg">
                <h2>Task Details</h2>
              </div>
              <div
                className="detailpara ql-editor-new"
                // Uncomment the next line if using DOMPurify
                // dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                dangerouslySetInnerHTML={{ __html: taskData?.description }}
              />
              <div className="mainheadingggg"></div>
              {taskData?.requirements && (
                <>
                  <h2 className="taskhead forheadingfont">
                    {" "}
                    Task Requirements
                  </h2>
                  <div
                    className="detailpara ql-editor-new"
                    // Uncomment the next line if using DOMPurify
                    // dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                    dangerouslySetInnerHTML={{ __html: taskData?.requirements }}
                  />
                </>
              )}
              {taskData?.additionalRequest && (
                <div className="mainheadingggg forbrdrrrrr">
                  <h2>Additional Requests</h2>
                  <div
                    className="detailpara ql-editor-new"
                    // Uncomment the next line if using DOMPurify
                    // dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                    dangerouslySetInnerHTML={{
                      __html: taskData?.additionalRequest,
                    }}
                  />
                </div>
              )}
            </div>
            <div className="detailsright">

              {/* <div className="innerdetailsright">
                <div className="detailtop">
                  <div className="detailinnerleft">
                    <p className="rewardpara">Reward</p>
                    <div className="rewardamount">
                      <div className="rewardimg">
                        <img
                          src={
                            tokenImages[taskData?.currencySymbol] ||
                            "/assets/createtask/usdc.svg"
                          }
                          alt="innerrewardimg"
                          className="innerrewardimg"
                        />
                      </div>
                      {taskData?.reward} {taskData?.currencySymbol}
                    </div>
                  </div>
                  <div className="detailinnerright">
                    <p className="participantpara">Participants</p>
                    <div className="partcipantmainhead">
                      {taskData?.participants?.slice(0, 4).map((e, i) => {
                        let classn;
                        if (i == 0) {
                          classn = "one";
                        } else if (i == 1) {
                          classn = "two";
                        } else if (i == 2) {
                          classn = "three";
                        } else {
                          classn = "four";
                        }
                        return (
                          <div className={`participantmain ${classn}`}>
                            <img
                              src={
                                e?.user?.imageUrl
                                  ? e?.user?.imageUrl
                                  : "/assets/edituploadimg.png"
                              }
                              alt="participantimg"
                              className="participantimg"
                            />
                          </div>
                        );
                      })}
                      {taskData?.participantCount === "0" && (
                        <div className="participantmain ">
                          <p className="numberimages">0</p>
                        </div>
                      )}
                      {taskData?.participantCount > 4 && (
                        <div className="participantmain five">
                          <p className="numberimages">
                            {`${taskData?.participantCount - 4}+`}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                
                <div className="maintimer">
                  <p className="endpara">Ends in</p>
                  {taskData?.participants?.[0]?.status === "winner" ? (
                    <TaskTimer
                      endTime={0}
                      fetchTaskData={fetchTaskData}
                    ></TaskTimer>
                  ) : (
                    <TaskTimer
                      endTime={taskData?.endTime}
                      fetchTaskData={fetchTaskData}
                    ></TaskTimer>
                  )}
                </div>
                {((taskData?.user?.walletAddress?.toLowerCase() === account?.toLowerCase()) && (new Date(taskData?.endTime) > new Date()) && (parseInt(taskData?.participantCount) === 0)) && <div className="edittask-toottip d-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#013159" />
                  </svg>
                  <p>You can edit a task as long as no participants have joined. Once someone joins, editing will be locked to keep things fair and avoid changing the requirements. Please note that the Reward Amount, Currency, Task Title, and Task Description cannot be edited at any stage.</p>
                </div>}
                {((taskData?.user?.walletAddress?.toLowerCase() === account?.toLowerCase()) && (new Date(taskData?.endTime) > new Date()) && (parseInt(taskData?.participantCount) === 0)) &&
                  <button
                    onClick={editTask}
                    className="participatebtnTwwo edittask-btnmbl"
                  >
                    Edit Task
                    <span style={{ marginLeft: '5px' }}>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltipEdit}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="13"
                          viewBox="0 0 12 13"
                          fill="none"
                        >
                          <path
                            d="M6 1.625C5.03582 1.625 4.09329 1.91091 3.2916 2.44659C2.48991 2.98226 1.86507 3.74363 1.49609 4.63442C1.12711 5.52521 1.03057 6.50541 1.21867 7.45107C1.40678 8.39672 1.87108 9.26537 2.55286 9.94715C3.23464 10.6289 4.10328 11.0932 5.04894 11.2813C5.99459 11.4694 6.97479 11.3729 7.86558 11.0039C8.75637 10.6349 9.51775 10.0101 10.0534 9.20841C10.5891 8.40672 10.875 7.46418 10.875 6.5C10.8736 5.20749 10.3596 3.96831 9.44564 3.05436C8.5317 2.14042 7.29251 1.62636 6 1.625ZM5.8125 3.875C5.92375 3.875 6.03251 3.90799 6.12501 3.9698C6.21751 4.03161 6.28961 4.11946 6.33218 4.22224C6.37476 4.32502 6.3859 4.43812 6.36419 4.54724C6.34249 4.65635 6.28892 4.75658 6.21025 4.83525C6.13158 4.91391 6.03136 4.96749 5.92224 4.98919C5.81313 5.0109 5.70003 4.99976 5.59724 4.95718C5.49446 4.91461 5.40661 4.84251 5.3448 4.75001C5.28299 4.65751 5.25 4.54875 5.25 4.4375C5.25 4.28832 5.30927 4.14524 5.41475 4.03975C5.52024 3.93426 5.66332 3.875 5.8125 3.875ZM6.375 9.125C6.17609 9.125 5.98532 9.04598 5.84467 8.90533C5.70402 8.76468 5.625 8.57391 5.625 8.375V6.5C5.52555 6.5 5.43016 6.46049 5.35984 6.39017C5.28951 6.31984 5.25 6.22446 5.25 6.125C5.25 6.02554 5.28951 5.93016 5.35984 5.85984C5.43016 5.78951 5.52555 5.75 5.625 5.75C5.82392 5.75 6.01468 5.82902 6.15533 5.96967C6.29598 6.11032 6.375 6.30109 6.375 6.5V8.375C6.47446 8.375 6.56984 8.41451 6.64017 8.48484C6.71049 8.55516 6.75 8.65054 6.75 8.75C6.75 8.84946 6.71049 8.94484 6.64017 9.01517C6.56984 9.08549 6.47446 9.125 6.375 9.125Z"
                            fill="#B4C2CD"
                          />
                        </svg>
                      </OverlayTrigger>
                    </span>
                  </button>}
              </div> */}


              <div className="detailsright">
                <TaskCard
                  taskData={taskData} curruntStatus={curruntStatus} id={id} uniqueStatus={uniqueStatus} uniqueCode={uniqueCode} fetchTaskData={fetchTaskData}
                  setTaskIds={setTaskIds} handleShow={handleShow} handleShow2={handleShow2} userId={userId} errorMsg={errorMsg}
                  isWinner={isWinner} createDispute={createDispute} setLoader={setLoader}
                />
              </div>


              {!TimerCheck ||
                taskData?.participants?.[0]?.status === "winner" ? (
                <>
                  {taskData?.participants?.[0]?.status === "winner" ? (
                    <>
                      <div className="innerdetailsright">
                        <p className="reviewpara text-center">
                          Creator has decided the following as winner
                        </p>
                        <div className="winnermain">
                          <p className="winnerpara">Winner:</p>

                          <div className="winnermainhead">
                            <div className="winnermainimg">
                              <img
                                src={
                                  taskData?.participants?.[0]?.user?.imageUrl
                                    ? taskData?.participants?.[0]?.user
                                      ?.imageUrl
                                    : "/assets/edituploadimg.png"
                                }
                                alt="winnerimg"
                                className="winnerimg"
                              />
                            </div>
                            <p className="winnerwallet">
                              {taskData?.participants?.[0]?.user?.walletAddress?.slice(
                                0,
                                5
                              )}
                              ...
                              {taskData?.participants?.[0]?.user?.walletAddress?.slice(
                                -3
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>

                      {taskData?.status !== "disputed" ? (
                        <>
                          {taskData?.status !== 'completed' ? (
                            <>
                              {/* {new Date(taskData?.coolDownPeriod) */}
                              {new Date(taskData?.reviewTimePeriod) <
                                new Date() ? (
                                // <>
                                //   {taskData?.disputeWinnerId ? (
                                //     <div className="innerdetailsright">
                                //       <h6 className="reviewhead">Results</h6>
                                //       <p className="reviewpara text-center">
                                //         DAO has decided to give you a refund
                                //       </p>
                                //       <button
                                //         className="withdrawbtn"
                                //         onClick={apiCallHandler1}
                                //       >
                                //         Claim Reward
                                //       </button>
                                //     </div>
                                //   ) : (
                                //     <div className="innerdetailsright">
                                //       <h6 className="reviewhead">Results</h6>
                                //       <p className="reviewpara text-center">
                                //         DAO has decided to give you a refund
                                //       </p>
                                //       <button
                                //         className="withdrawbtn"
                                //         onClick={apiCallHandler}
                                //       >
                                //         Claim Reward
                                //       </button>
                                //     </div>
                                //   )}
                                // </>
                                null
                              ) : (
                                <div className="innerdetailsright">
                                  <h6 className="reviewhead">Review</h6>

                                  <div className="maintimer">
                                    <TaskTimer
                                      endTime={taskData?.reviewTimePeriod}
                                      fetchTaskData={fetchTaskData}
                                    />
                                    {/* <TaskTimer endTime={taskData?.endTime} /> */}
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="innerdetailsright">
                              <h6 className="reviewhead">Results</h6>

                              <button className="fundwithdrawnbtn">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="15"
                                  height="11"
                                  viewBox="0 0 15 11"
                                  fill="none"
                                >
                                  <path
                                    d="M14.6483 1.46078L5.64828 10.4608C5.59604 10.5131 5.534 10.5546 5.46572 10.5829C5.39743 10.6112 5.32423 10.6258 5.25031 10.6258C5.17639 10.6258 5.1032 10.6112 5.03491 10.5829C4.96662 10.5546 4.90458 10.5131 4.85234 10.4608L0.914844 6.52328C0.809296 6.41773 0.75 6.27458 0.75 6.12531C0.75 5.97605 0.809296 5.83289 0.914844 5.72734C1.02039 5.6218 1.16355 5.5625 1.31281 5.5625C1.46208 5.5625 1.60523 5.6218 1.71078 5.72734L5.25031 9.26758L13.8523 0.664844C13.9579 0.559296 14.101 0.5 14.2503 0.5C14.3996 0.5 14.5427 0.559296 14.6483 0.664844C14.7538 0.770392 14.8131 0.913546 14.8131 1.06281C14.8131 1.21208 14.7538 1.35523 14.6483 1.46078Z"
                                    fill="#013159"
                                  />
                                </svg>
                                Funds Withdrawn
                              </button>
                            </div>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </>
              ) : (
                ""
              )}

              {/* <p className="createdbypara">Created By</p>
                            <div className="creatormain">
                                <div className="creatormainimg">
                                    <img src="/assets/dummyassets/dummysix.png" alt="creatorimg" className="creatorimg" />
                                </div>
                                <p className="creatorwallet">0xa12s..14ws</p>
                            </div> */}
              {(taskData?.status !== 'completed') && (!taskData?.winnerSelected) ? (
                <>
                  {(new Date(taskData?.endTime) < new Date() && new Date(taskData?.reviewTimePeriod) < new Date() && new Date(taskData?.coolDownPeriod) < new Date() && new Date(taskData?.votingEndPeriod) < new Date()) ? (
                    <div className="innerdetailsright">
                      <div className="time-ended">
                        <h6>Task Ended</h6>
                        <p>{
                          (extended)
                            ? <>No submissions have been received for this task. Would you like to extend the task duration?</>
                            : null
                        }</p>
                        {/* {console.log('aljdflaf', (taskData?.submissionCount) < 1 && (!taskData?.isEndTimeExtended))} */}
                        <div className="twice-btns">
                          {
                            (extended)
                              ? <button
                                style={{
                                  filter: (extended) ? 'opacity(1)' : 'opacity(0.4)'
                                }}
                                onClick={extended ? handleShow3 : taskData?.isEndTimeExtended ? () => CustomToast.show('warning', 'Warning!', 'Time has already been extended.')




                                  : null}
                                className="btn-extend"
                              >
                                Extend Duration
                              </button>
                              : null
                          }

                          {taskData?.disputeWinnerId ? (
                            <button disabled={new Date(taskData?.reviewTimePeriod) > new Date()} onClick={apiCallHandler1} className={extended ? "btn-withdraw" : "btn-withdraw  w-100"}>Withdraw</button>
                          ) : (
                            <button disabled={new Date(taskData?.reviewTimePeriod) > new Date()} onClick={apiCallHandler} className={extended ? "btn-withdraw " : "btn-withdraw  w-100"}>Withdraw</button>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : null}
                </>
              ) : null}

            </div>
          </div>
          {
            taskData?.hasCreator === true &&
            <>
              <h6 className="mainpartcipanthead">Submissions</h6>
              <div className="createdtasktable">
                {arry.length > 0 ? (
                  <table>
                    <thead>
                      <th>Name</th>
                      <th>Date Participated</th>
                      <th>Proof of Work</th>
                    </thead>
                    <tbody>
                      {arry?.map((ee) => {
                        const date = moment(ee.dateParticipated);
                        const formattedDate = date.format("DD/MM/YYYY");

                        // console.log(ee, "dsyfguysdgfuyasdgfu")
                        return (
                          <tr>
                            <td>
                              <p className="tablepara">
                                {ee?.user?.name ? ee?.user?.name :
                                  // ee?.user?.walletAddress
                                  <>
                                    {ee?.user?.walletAddress?.slice(0, 8)} ... {ee?.user?.walletAddress?.slice(-4)}
                                  </>
                                }
                              </p>
                            </td>
                            <td>
                              <p className="tablepara">{formattedDate}</p>
                            </td>
                            <td>
                              {/* {taskData?.participants?.map((participant, idx) => {
                            const isWinner = participant?.status == 'winner';
                            const isCreator = taskData?.hasCreator === true;

                            return (
                              <div key={participant?.id}>
                                <p>Participant #{idx + 1}</p>

                                {isWinner ? (
                                  <button
                                    onClick={() => isCreator && clickme(participant)}
                                    disabled={!isCreator}
                                    className={
                                      isCreator
                                        ? "viewpara btnwhenclickable"
                                        : "viewpara disableviewparabtn"
                                    }
                                  >
                                    View Files (Only for creator....)
                                  </button>
                                ) : (
                                  <button
                                    disabled
                                    className="viewpara disableviewparabtn"
                                  >
                                    View Files 0000
                                  </button>
                                )}
                              </div>
                            );
                          })} */}


                              <button
                                onClick={() => clickme(ee)}
                                // disabled={
                                //   taskData?.status === 'completed'
                                //     ? true
                                //     : taskData?.participants?.[0]?.status ===
                                //       "winner"
                                //       ? true
                                //       : false
                                // }
                                className={
                                  "viewpara btnwhenclickable"
                                  // taskData?.status === 'completed'
                                  //   ? true
                                  //   : taskData?.participants?.[0]?.status ===
                                  //     "winner"
                                  //     ? "viewpara disableviewparabtn"
                                  //     : "viewpara btnwhenclickable"
                                }
                              >
                                View Files
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <table>
                    <thead>
                      <th>Name</th>
                      <th>Date Participated</th>
                      <th>Proof of Work</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan={3}>
                          <h6 className="nodata-text">No Data Found!</h6>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}

                {/* <div className="left-f">
          <h6>
                {" "}
                {count > 0 && count <= 5 ? (
                  <>
                    <p>
                      SHOWING 1-{count} OF {count}
                    </p>
                  </>
                ) : count > 5 ? (
                  <>
                    <p>
                      SHOWING {page > 0 ? page * 5 + 1 : page + 1} -
                      {5 * (page + 1) > count ? count : 5 * (page + 1)} OF{" "}
                      {count}
                    </p>
                  </>
                ) : (
                  <>
                    <p>SHOWING 0 OF 0</p>
                  </>
                )}
              </h6>
          </div> */}
                {pages > 1 && (
                  <div className="paginationmain">

                    <ReactPaginate
                      previousLabel={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M10 13L5 8L10 3"
                            stroke="#fff"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      }
                      nextLabel={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M5 13L10 8L5 3"
                            stroke="#fff"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      }
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageChange}
                      containerClassName="pagination"
                      activeClassName="active"
                      forcePage={page}
                    ></ReactPaginate>
                  </div>
                )}
              </div>
            </>
          }
        </div>
      </section>

      <Modal show={show} onHide={handleClose} className="modal_mainr" centered>
        <Modal.Header closeButton>
          <Modal.Title>Proof of Work</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal3">
            <div className="subnmatouterdiv">
              <div className="">
                <p className="submitted">Submitted By</p>
                {/* {console.log(proveOfWorkUser)} */}
              </div>

              <div className="secdiv">
                <img
                  src={
                    proveOfWorkUser?.user?.imageUrl
                      ? proveOfWorkUser?.user?.imageUrl
                      : "/assets/edituploadimg.png"
                  }
                  alt="winner"
                  className="inerimgg"
                />
                <p className="namewithimg">
                  {/* {console.log(proveOfWorkUser.user.name, "winnersssss ")} */}
                  {proveOfWorkUser?.user?.name ? proveOfWorkUser?.user?.name :
                    // proveOfWorkUser?.user?.walletAddress
                    <>
                      {proveOfWorkUser?.user?.walletAddress?.slice(0, 8)} ... {proveOfWorkUser?.user?.walletAddress?.slice(-4)}
                    </>
                  }
                </p>
              </div>
            </div>
            <div className="msgdiv">
              <h1 className="msghfdng">Message</h1>
              <p className="inermsgpars">
                {proveOfWorkUser?.message
                  ? makeUrlsClickable(proveOfWorkUser.message)
                  : ""}
              </p>
              <div className="mainscrooldiv">
                {proveOfWorkUser?.proofOfWork?.map((e) => {
                  return (
                    <div className="inerscrooldiv setcustom-twice-withdownload">
                      <p className="dddooeenger">{e.split("-").pop()}</p>

                      <p
                        className="dddooeengerright"
                        onClick={() => {
                          download(e);
                        }}
                      >
                        <spam>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M17.5 11.25V16.25C17.5 16.4158 17.4342 16.5747 17.3169 16.6919C17.1997 16.8092 17.0408 16.875 16.875 16.875H3.125C2.95924 16.875 2.80027 16.8092 2.68306 16.6919C2.56585 16.5747 2.5 16.4158 2.5 16.25V11.25C2.5 11.0842 2.56585 10.9253 2.68306 10.8081C2.80027 10.6908 2.95924 10.625 3.125 10.625C3.29076 10.625 3.44973 10.6908 3.56694 10.8081C3.68415 10.9253 3.75 11.0842 3.75 11.25V15.625H16.25V11.25C16.25 11.0842 16.3158 10.9253 16.4331 10.8081C16.5503 10.6908 16.7092 10.625 16.875 10.625C17.0408 10.625 17.1997 10.6908 17.3169 10.8081C17.4342 10.9253 17.5 11.0842 17.5 11.25ZM9.55781 11.6922C9.61586 11.7503 9.68479 11.7964 9.76066 11.8279C9.83654 11.8593 9.91787 11.8755 10 11.8755C10.0821 11.8755 10.1635 11.8593 10.2393 11.8279C10.3152 11.7964 10.3841 11.7503 10.4422 11.6922L13.5672 8.56719C13.6253 8.50912 13.6713 8.44018 13.7027 8.36431C13.7342 8.28844 13.7503 8.20712 13.7503 8.125C13.7503 8.04288 13.7342 7.96156 13.7027 7.88569C13.6713 7.80982 13.6253 7.74088 13.5672 7.68281C13.5091 7.62474 13.4402 7.57868 13.3643 7.54725C13.2884 7.51583 13.2071 7.49965 13.125 7.49965C13.0429 7.49965 12.9616 7.51583 12.8857 7.54725C12.8098 7.57868 12.7409 7.62474 12.6828 7.68281L10.625 9.74141V2.5C10.625 2.33424 10.5592 2.17527 10.4419 2.05806C10.3247 1.94085 10.1658 1.875 10 1.875C9.83424 1.875 9.67527 1.94085 9.55806 2.05806C9.44085 2.17527 9.375 2.33424 9.375 2.5V9.74141L7.31719 7.68281C7.19991 7.56554 7.04085 7.49965 6.875 7.49965C6.70915 7.49965 6.55009 7.56554 6.43281 7.68281C6.31554 7.80009 6.24965 7.95915 6.24965 8.125C6.24965 8.29085 6.31554 8.44991 6.43281 8.56719L9.55781 11.6922Z"
                              fill="#013159"
                            />
                          </svg>
                        </spam>
                        Download
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            {/* <button className="cancelbutton" onClick={handleClose2}>CANCEL</button> */}
            {/* {new Date() > new Date(taskData?.reviewTimePeriod) ? null : ( */}
            {
              new Date() > new Date(taskData?.reviewTimePeriod) || taskData?.winnerSelected == false &&
              <button
                className="surebutton"
                onClick={() => {
                  handleClose();
                  handleShow1();
                }}
              >
                Approve Claim
              </button>
            }
            {/* )} */}
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show1}
        onHide={handleClose1}
        className="modal_mainr"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Winner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 70 70"
              fill="none"
            >
              <rect
                x="5"
                y="5"
                width="60"
                height="60"
                stroke="#013159"
                stroke-width="2"
              />
              <rect x="34" y="18" width="2" height="28" fill="#013159" />
              <rect x="34" y="49" width="2" height="3" fill="#013159" />
            </svg>
            <h1>Are you confident about your decision?</h1>
            {/* <p className="parssa">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            <button className="cancelbutton" onClick={handleClose1}>
              Cancel
            </button>
            <button
              className="surebutton"
              onClick={() => {
                winnerFinal();
              }}
            >
              Yes, I’m Sure
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show2}
        onHide={handleClose2}
        className="modal_mainr"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 70 70"
              fill="none"
            >
              <rect
                x="5"
                y="5"
                width="60"
                height="60"
                stroke="#013159"
                stroke-width="2"
              />
              <rect
                x="28.2036"
                y="49.8564"
                width="2"
                height="40.2235"
                transform="rotate(-135 28.2036 49.8564)"
                fill="#013159"
              />
              <rect
                x="17"
                y="38.625"
                width="2"
                height="15.43"
                transform="rotate(-45 17 38.625)"
                fill="#013159"
              />
            </svg>
            {createrState ? (
              <h1>Refund Successfully </h1>
            ) : (
              <h1>Winner Successfully Selected</h1>
            )}

            {/* <p className="parssa">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p> */}
          </div>

          {createrState ? (
            ""
          ) : (
            <div className="mainscrooldiv2nd">
              <div className="inerscrooldiv2nd">
                <p className="dddooeenger">Winner:</p>
                {/* <div className="secdiv2nd">
                                    <img src={taskData?.user?.imageUrl ? taskData?.user?.imageUrl : '/assets/edituploadimg.png'} className="inerimgg" />
                                    <p className="namewithimg">
                                        {taskData?.user?.name ? taskData?.user?.name : taskData?.user?.walletAddress?.slice(0,10)}
                                    </p>
                                </div> */}
                <div className="secdiv2nd">
                  <img
                    src={
                      proveOfWorkUser?.user?.imageUrl
                        ? proveOfWorkUser?.user?.imageUrl
                        : "/assets/edituploadimg.png"
                    }
                    alt="(WinnerName)"
                    className="inerimgg"
                  />
                  <p className="namewithimg">
                    {proveOfWorkUser?.user?.name
                      ? proveOfWorkUser?.user?.name
                      : "anonymous"}
                  </p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            <button className="surebutton" onClick={handleClose2}>
              OK
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show4}
        onHide={handleClose4}
        className="modal_mainr"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Claim Reward</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 70 70"
              fill="none"
            >
              <rect
                x="5"
                y="5"
                width="60"
                height="60"
                stroke="#013159"
                stroke-width="2"
              />
              <rect x="34" y="18" width="2" height="28" fill="#013159" />
              <rect x="34" y="49" width="2" height="3" fill="#013159" />
            </svg>
            <h1>
              Are you sure you want to claim a refund <br />
              {taskData?.reward} {taskData?.currency} for this task?
            </h1>
            <p className="parssa">
              The reward sum will be transferred to your connected wallet.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            <button className="cancelbutton" onClick={handleClose4}>
              Cancel
            </button>
            <button
              className="surebutton"
              onClick={() => {
                // console.log('sdsddasdasdsa chala',taskData?.disputeWinnerId);
                // claimToken()
                if (taskData?.disputeWinnerId) {
                  claimToken1();
                } else {
                  claimRefund();
                }
              }}
            >
              Yes, I’m Sure
            </button>
          </div>
        </Modal.Footer>
      </Modal>



      <Modal
        show={show3}
        onHide={handleClose3}
        className="modal_mainr extendduration-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Extend Task Duration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="extend-duration">
            <div className="option-parent">
              <div className="upper-field">
                <p>Task End Date</p>
                <h6>Current Time: {currentTime} UCT</h6>
              </div>
              <div className="option-field">
                <input
                  type="datetime-local"
                  onChange={(e) => setNewEndTime(e.target.value)}
                  placeholder="DD/MM/YY --:--"
                  min={new Date().toISOString().slice(0, -8)} // Set minimum date-time to current
                />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M8 2V5" stroke="#013159" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M16 2V5" stroke="#013159" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M3.5 9.08997H20.5" stroke="#013159" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="#013159" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M15.6947 13.7H15.7037" stroke="#013159" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M15.6947 16.7H15.7037" stroke="#013159" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M11.9955 13.7H12.0045" stroke="#013159" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M11.9955 16.7H12.0045" stroke="#013159" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M8.29431 13.7H8.30329" stroke="#013159" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M8.29431 16.7H8.30329" stroke="#013159" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
            <div className="bottom-detail">
              <h6>Task duration cannot exceed 30 Days</h6>
            </div>
            <div className="bottom-btns">
              <a onClick={handleClose3} className="btn-cancel">Cancel</a>
              <a onClick={handleConfirm} className="btn-confirm">Confirm</a>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show5}
        onHide={handleClose5}
        className="modal_mainr"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 70 70"
              fill="none"
            >
              <rect
                x="5"
                y="5"
                width="60"
                height="60"
                stroke="#013159"
                stroke-width="2"
              />
              <rect
                x="28.2036"
                y="49.8564"
                width="2"
                height="40.2235"
                transform="rotate(-135 28.2036 49.8564)"
                fill="#013159"
              />
              <rect
                x="17"
                y="38.625"
                width="2"
                height="15.43"
                transform="rotate(-45 17 38.625)"
                fill="#013159"
              />
            </svg>
            <h1>The due date has been extended! </h1>

            <p className="parssa">The task is now active on the website and open for participants.</p>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            <button className="surebutton" onClick={handleClose5}>
              Done
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Tasksdetails;
